<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="8">
        <b-row>
          <b-col cols="12" md="3">
            <b-img
              thumbnail
              fluid
              :src="
                pathOr(defaultImg, ['person', 'attachment', 'url'], generalData)
              "
            />
            <attachmentModal
              :attachmentModel="showAttachmentModal"
              :code="personCode"
              :title="$lang.finalReportAttachmentTitle"
              @updateModal="updateModal"
            >
              <template slot="clickArea">
                <b-button
                  block
                  variant="primary"
                  @click="updateModal(true)"
                  v-text="$lang.otherImagesButton"
                />
              </template>
            </attachmentModal>
          </b-col>
          <b-col cols="12" md="9">
            <h3
              v-text="
                `${pathOr('', ['person', 'name'], generalData)} ${pathOr(
                  '',
                  ['person', 'family'],
                  generalData
                )}`
              "
            />
            <ul class="list-unstyled mt-3 ml-3">
              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'تاریخ تولد: '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr('', ['person', 'birth_date', 'jalali'], generalData)
                  "
                />
              </li>
              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'وضعیت تاهل: '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr('', ['person', 'marriage_caption'], generalData)
                  "
                />
              </li>
              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'ساکن: '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr(
                      '',
                      ['person', 'sokonat_location_caption'],
                      generalData
                    )
                  "
                />
              </li>
              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'مذهب: '" />
                <span
                  class="text-muted"
                  v-text="pathOr('', ['person', 'allegiance'], generalData)"
                />
              </li>

              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'نوع پذیرش: '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr('', ['person', 'request_type_caption'], generalData)
                  "
                />
              </li>
              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'حوزه قضایی: '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr(
                      '',
                      ['person', 'hoze_ghazaei_location_caption'],
                      generalData
                    )
                  "
                />
              </li>

              <li class="mb-3">
                <i class="far fa-check-circle text-info mr-2" />
                <strong v-text="'فارغ التحصیل رشته: '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr('', ['person', 'education_field'], generalData)
                  "
                />
                <strong v-text="' از '" />
                <span
                  class="text-muted"
                  v-text="
                    pathOr('', ['person', 'education_place'], generalData)
                  "
                />
              </li>
            </ul>
            <div class="p-3 rounded bg-light">
              <i class="fas fa-desktop mr-1" />
              <strong v-text="$lang.suggestSystemComment" class="mr-3" />
              <strong
                class="text-muted"
                v-text="pathOr('', ['system_suggest_idea'], generalData)"
              />
            </div>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" md="4" class="text-center pt-3">
        <circleChart
          :title="$lang.tabOnePieChartTitle"
          :data="pathOr([], ['assessment_status'], generalData)"
        />
      </b-col>
      <b-col cols="12" md="12" class="bg-light rounded p-3 mt-3">
        <strong class="fs_16" v-text="$lang.finalReportStrongerFactorsTitle" />
        <ul class="list-unstyled mt-3 ml-3">
          <li
            class="mb-3"
            v-for="(item, index) in pathOr(
              [],
              ['stronger_factors'],
              generalData
            )"
            :key="index"
          >
            <i class="far fa-check-circle text-success mr-2" />
            <span class="text-success" v-text="item" />
          </li>
        </ul>
        <strong class="fs_16" v-text="$lang.finalReportWeaknessFactorsTitle" />
        <ul class="list-unstyled mt-3 ml-3">
          <li
            class="mb-3"
            v-for="(item, index) in pathOr(
              [],
              ['weakness_factors'],
              generalData
            )"
            :key="index"
          >
            <i class="far fa-times-circle text-danger mr-2" />
            <span class="text-danger" v-text="item" />
          </li>
        </ul>
      </b-col>
      <b-col cols="12" md="12" class="bg-light rounded p-3 mt-3">
        <matrixTable
          :title="$lang.finalReportMatrixTitle"
          :fields="matrixFields"
          :items="pathOr([], ['score_competency'], generalData)"
        />
      </b-col>
      <b-col cols="12" md="12" class="mt-3 p-0">
        <searchVotes />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import searchVotes from "./searchVotes.vue";
import { pathOr } from "ramda";
import matrixTable from "./matrixTable.vue";
import circleChart from "./circleChart.vue";
import attachmentModal from "./attachmentModal.vue";

export default {
  components: {
    searchVotes,
    matrixTable,
    circleChart,
    attachmentModal,
  },
  data() {
    return {
      defaultImg: $config.images.tinyLogo,
      values: [],
      chartData: {},
      generalData: {},
      textColor: ["#e4e5e6", "#4dbd74", "#f86c6b", "#ffc107"],
      code: this.$route.params.code,
      matrixFields: [
        {
          key: "caption",
          label: "عنوان",
          isRowHeader: true,
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "bg-info p-1",
        },
        {
          key: "score0",
          label: "آزمون کتبی",
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "p-1",
        },
        {
          key: "score1",
          label: "مصاحبه علمی",
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "p-1",
        },
        {
          key: "score2",
          label: "مصاحبه بینشی",
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "p-1",
        },
        {
          key: "score3",
          label: "تحقیقات",
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "p-1",
        },
      ],
      showAttachmentModal: false,
      personCode: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    updateModal(data) {
      this.showAttachmentModal = data;
    },
    async fetchData() {
      try {
        this.$emit("setLoading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_general.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.generalData = {
          ...pathOr({}, ["data", "data"], response),
        };
        this.personCode = pathOr(
          "",
          ["data", "data", "person", "code"],
          response
        );

        this.values =
          this.generalData && this.generalData.assessment_status.values;
        this.chartData = {
          hoverBackgroundColor: "red",
          hoverBorderWidth: 10,
          labels: this.generalData && this.generalData.assessment_status.labels,
          datasets: [
            {
              backgroundColor: ["#e4e5e6", "#4dbd74", "#f86c6b", "#ffc107"],
              data: [90, 90, 90, 90],
            },
          ],
        };
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("setLoading", false);
      }
    },
  },
};
</script>
